import { render } from "./oaBanner.vue?vue&type=template&id=8c3f2b48&scoped=true"
import script from "./oaBanner.vue?vue&type=script&lang=js"
export * from "./oaBanner.vue?vue&type=script&lang=js"

import "./oaBanner.vue?vue&type=style&index=0&id=8c3f2b48&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c3f2b48"]])

export default __exports__